<div class="container py-4 text-primary" *transloco="let t">
  <div class="row">
    <div class="col">

      @if(showCaptcha()) {
        <form [formGroup]="captchaForm">
          <div class="alert alert-warning mt-2" role="alert">
            <h4 class="alert-heading">
              {{ t('auth.validateEmail.CaptchaTitle') }}
            </h4>
            <p class="my-2">
              {{ t('auth.validateEmail.CaptchaMsg') }}
              <app-altcha formControlName="captcha" class="my-1" (onVerified)="validateUser()"/>
            </p>
          </div>
        </form>
      }

      @if (showInvalidLink()) {
        <div class="alert alert-danger mt-2" role="alert">
          <p class="my-2">
            Ce lien n'est pas valide ou a expiré.
          </p>
        </div>
      }

      @if (isValidated()) {
        <div class="alert alert-success mt-2" role="alert">
          <p class="my-2">
            Ton adresse email est validée
          </p>
        </div>

        <p class="my-2 text-end">
          <a [routerLink]="routes.dashboard" class="btn btn-primary">Mon tableau de bord</a>
        </p>
      }

      @if (validating()) {
        <app-spinner [message]="t('auth.validateEmail.Validating')"></app-spinner>
      }

      @if (showResend()) {
        <div class="d-flex justify-content-end mt-2">
          <button type="button" class="btn btn-link" (click)="resendValidationEmail()">
            {{ t('auth.validateEmail.Resend', {email: authenticatedUser()?.userName}) }}
          </button>
        </div>
      }

      @if (showResendLogin()) {
        <div class="d-flex justify-content-end mt-2">
          <button type="button" class="btn btn-link" (click)="toggleShowLogin()">
            {{ t('auth.validateEmail.ResendAnonymous') }}
          </button>
        </div>
      }

      @if (resentValidationEmail()) {
        <div class="alert alert-success mt-2" role="alert">
          <p class="my-2">
            Un email de validation a été envoyé à {{ this.resentValidationEmailTo() }}
          </p>
        </div>
      }

      @if (validationError()) {
        <div class="alert alert-danger mt-2" role="alert">
          <h4 class="alert-heading">
            Nous n'avons pas pu valider ton email.
          </h4>
          <p>A-t'elle déjà été validée?</p>
          <p>Besoin d'aide? contacte notre support.</p>
        </div>
      }

      @if (showLogin()) {
        <app-login
          [loginBtnLabel]="'Connexion'"
          [canRegister]="false"
          [redirect]="false"
          (onLogin)="resendValidationEmail($event)">
        </app-login>
      }

      <p class="text-end">
        <app-contact-support></app-contact-support>
        <a class="btn btn-link mx-1" [routerLink]="routes.login">
          {{ t('auth.register.Login') }}
          <lucide-icon [img]="icons.login"></lucide-icon>
        </a>
      </p>

    </div>
  </div>
</div>

